import { render, staticRenderFns } from "./flag.vue?vue&type=template&id=e8d99c70&scoped=true&"
import script from "./flag.js?vue&type=script&lang=js&"
export * from "./flag.js?vue&type=script&lang=js&"
import style0 from "./flag.vue?vue&type=style&index=0&id=e8d99c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d99c70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8d99c70')) {
      api.createRecord('e8d99c70', component.options)
    } else {
      api.reload('e8d99c70', component.options)
    }
    module.hot.accept("./flag.vue?vue&type=template&id=e8d99c70&scoped=true&", function () {
      api.rerender('e8d99c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/flag.vue"
export default component.exports